import React, { useState } from 'react'

import cx from 'classnames'
import { BadgeCountsSelector } from 'conversations/components/NewChatSidebar/ConversationListHeader'
import InboxSwitcher from 'conversations/components/NewChatSidebar/InboxSwitcher'
import InboxSwitcherItem from 'conversations/components/NewChatSidebar/InboxSwitcherItem'
import SearchTrigger from 'conversations/components/SearchTrigger'
import useBadgeCounts from 'conversations/hooks/useBadgeCounts'
import { useEnabledInboxes } from 'conversations/hooks/useInboxes'
import useSetInbox from 'conversations/hooks/useSetInbox'
import { getActiveInbox } from 'conversations/modules/user/selectors'
import { useSelector } from 'react-redux'

import { IconButton } from '@driftt/dds'
import { faMagnifyingGlass } from '@driftt/dds.icons/regular/faMagnifyingGlass'

import styles from './styles.module.css'

export const SidebarHeader: React.FC = () => {
  const [inboxListOpen, setInboxListOpen] = useState(false)
  const inboxes = useEnabledInboxes()
  const hasWorkspaces = useSelector(
    (state: { workspaces: { workspace: [] } }) => Object.keys(state.workspaces.workspace).length > 0
  )

  const hasAllInboxes = inboxes.length > 1 || hasWorkspaces

  const { setInboxState } = useSetInbox()
  const activeInbox = useSelector(getActiveInbox)

  const inboxCounts: Record<number, number> =
    inboxes?.reduce((acc, inbox) => {
      return {
        ...acc,
        [inbox.id]: inbox.openConversationCount,
      }
    }, {}) ?? {}
  const allInboxesCount = Object.values(inboxes).reduce(
    (acc, inbox) => acc + inboxCounts[inbox.id],
    0
  )

  const myConversationBadgeCounts: BadgeCountsSelector = useBadgeCounts()
  const { total: badgeTotal } = myConversationBadgeCounts

  const calcBadgeCount = (inboxId: number) =>
    myConversationBadgeCounts[inboxId] ? Object.keys(myConversationBadgeCounts[inboxId]).length : 0
  const defaultInboxName = 'All inboxes'
  return (
    <header
      className={cx(styles.header, { [styles.hoverable]: hasAllInboxes })}
      onClick={() => hasAllInboxes && setInboxListOpen(true)}>
      <InboxSwitcher
        isOpen={inboxListOpen}
        setIsOpen={setInboxListOpen}
        selectedInboxName={
          activeInbox?.name || hasAllInboxes
            ? activeInbox?.name ?? defaultInboxName
            : inboxes?.[0]?.name ?? defaultInboxName
        }
        badgeCount={badgeTotal}
        hasSelectDropdown={hasAllInboxes}>
        <InboxSwitcherItem
          name={defaultInboxName}
          dataInbox={null}
          onClick={setInboxState}
          isSelected={activeInbox === undefined}
          count={allInboxesCount}
          badgeCount={badgeTotal}
        />
        {hasAllInboxes &&
          inboxes?.map((inbox) => (
            <InboxSwitcherItem
              dataInbox={inbox}
              name={inbox.name}
              key={inbox.id}
              onClick={setInboxState}
              isSelected={activeInbox?.id === inbox.id}
              count={inboxCounts[inbox.id] ?? inbox.openConversationCount}
              badgeCount={calcBadgeCount(inbox.id)}
            />
          ))}
      </InboxSwitcher>
      <SearchTrigger>
        <IconButton
          className={styles.search}
          title="Search"
          variant="tertiary"
          iconVariant="gray"
          icon={faMagnifyingGlass}
        />
      </SearchTrigger>
    </header>
  )
}
